<template>
  <div id="add">
    <Loading v-if="loading"></Loading>
    <van-form class="content">
      <van-cell-group inset>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.scName"
            name="scName"
            inputmode="none"
            label="仓库"
            readonly
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.supplierName"
            name="supplierName"
            inputmode="none"
            label="供应商"
            readonly
        /></van-cell>
        <van-cell @click="openDateTimePicker('form', 'paymentDate')">
          <van-field
            autocomplete="off"
            v-model="form.paymentDate"
            name="paymentDate"
            inputmode="none"
            required
            label="付款日期"
        /></van-cell>
        <van-cell @click="openDateTimePicker('form', 'receiveDate')">
          <van-field
            autocomplete="off"
            v-model="form.receiveDate"
            inputmode="none"
            name="receiveDate"
            required
            label="实际到货日期"
        /></van-cell>
        <!-- <van-cell @click="showPurchaseOrderSelect"> -->
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.purchaseOrderId"
            name="purchaseOrderId"
            readonly
            required
            inputmode="none"
            label="采购收货单"
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.description"
            rows="1"
            autosize
            label="备注"
            type="textarea"
          />
        </van-cell>
      </van-cell-group>
      <van-form style="margin-top: 5px" class="product-list">
        <div class="flex-between top">
          <div>商品列表</div>
        </div>
        <van-cell v-for="(item, i) in form.tableData">
          <div class="product" @click="toDetail(item)">
            <div class="flex flex-start">
              <div class="tit">{{ item.productName }}</div>
              <div class="price">
                <span>￥{{ item.purchasePrice }}</span
                >/{{ item.unit }}
              </div>
              <div class="desc">剩余可收货数量:{{ item.remainNum || "-" }}</div>
            </div>
            <div class="flex flex-end">
              <div class="total">
                ￥{{ $utils.mul(item.purchasePrice, item.receiveNum) }}
              </div>
              <div>
                <div class="numChangeBox" @click.stop="">
                  <van-icon
                    class="circleIcon"
                    name="minus"
                    @click="minus($event, i, 'receiveNum')"
                  />
                  <van-field
                    class="numInput"
                    autocomplete="off"
                    type="number"
                    v-model="item.receiveNum"
                  >
                  </van-field>
                  <van-icon
                    class="circleIcon"
                    name="plus"
                    @click="plus($event, i, 'receiveNum')"
                  />
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-form>

      <div style="margin: 16px 0">
        <van-form>
          <van-cell>合计</van-cell>
          <van-cell-group>
            <van-cell
              ><van-field
                autocomplete="off"
                label="收货数量"
                readonly
                v-model="form.totalNum"
                type="number"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="赠品数量"
                readonly
                type="number"
                v-model="form.giftNum"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="含税总金额"
                readonly
                type="number"
                v-model="form.totalAmount"
            /></van-cell>
          </van-cell-group>
        </van-form>
        <van-cell class="actions-btn">
          <van-button
            type="primary"
            @click="onAddConfirm"
            round
            block
            :loading="loading"
            >保存</van-button
          >
          <van-button
            type="info"
            @click="toDirectApprovePass"
            round
            block
            :loading="loading"
            v-permission="'purchase:receive:approve'"
            >直接审批通过</van-button
          >
          <van-button
            @click="close"
            type="default"
            round
            block
            :loading="loading"
            >关闭</van-button
          >
        </van-cell>
      </div>
    </van-form>
    <ProductSelect
      type="order"
      columnsType="checkbox"
      :scId="this.form.scId"
      :visible="showProductSelect"
      @confirm="onSelectProductConfirm"
    ></ProductSelect>
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
  </div>
</template>

<script>
import {
  create,
  directApprovePass,
  getPaymentDate,
} from "../../../service/api/purchase/receive";
import ProductSelect from "../../../components/productSelect.vue";
import DateTimePicker from "../../../components/dateTimePicker.vue";
import { Notify, Toast, Dialog } from "vant";
import moment from "moment";
import {
  getWithReceive,
  queryPurchaseProductList,
} from "../../../service/api/purchase/order";
import Loading from "../../../components/loading.vue";

export default {
  name: "index",
  components: {
    ProductSelect,
    DateTimePicker,
    Loading,
  },
  data() {
    return {
      loading: false,
      purchaseOrderSelectVisible: false,
      showDatePicker: false,
      showDatePicker: false,
      stockSelectVisible: false,
      supplierSelectVisible: false,
      showProductSelect: false,
      datePickType: "product",
      form: {},
      tableData: [],
      tableData2: [],
      columns: [
        {
          field: "productName",
          key: "productName",
          title: "商品名称",
          width: 100,
          fixed: "left",
        },
        {
          field: "productCode",
          key: "productCode",
          title: "商品编号",
          width: 80,
        },
        { field: "unit", key: "unit", title: "单位", width: 80 },
        { field: "spec", key: "spec", title: "规格", width: 80 },
        {
          field: "productionDate",
          key: "productionDate",
          title: "生产日期",
          width: 130,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="productionDate"
                value={text}
                on-click={() => this.openDateTimePicker("product", rowIndex)}
              ></van-field>
            );
          },
        },
        {
          field: "shelfLifeDays",
          key: "shelfLifeDays",
          title: "保质期时长（天）",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="shelfLifeDays"
                value={text}
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "categoryName",
          key: "categoryName",
          title: "商品类目",
          width: 80,
        },
        {
          field: "isGift",
          key: "isGift",
          title: "是否赠品",
          width: 50,
          formatter: ({ cellValue }) => {
            return cellValue ? "是" : "否";
          },
        },
        { field: "brandName", key: "brandName", title: "商品品牌", width: 80 },
        {
          field: "purchasePrice",
          key: "purchasePrice",
          title: "采购价（元）",
          align: "right",
          width: 100,
        },
        { field: "stockNum", key: "stockNum", title: "库存数量", width: 100 },
        {
          field: "orderNum",
          key: "orderNum",
          title: "采购数量",
          align: "right",
          width: 100,
        },
        {
          field: "remainNum",
          key: "remainNum",
          title: "剩余收货数量",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const value = this.$utils.sub(row.remainNum, row.receiveNum);
            return <span>{value}</span>;
          },
        },
        {
          field: "receiveNum",
          key: "receiveNum",
          title: "收货数量",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="receiveNum"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "taxAmount",
          key: "taxAmount",
          title: "含税金额",
          align: "right",
          width: 80,
        },
        {
          field: "description",
          key: "description",
          title: "备注",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="description"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "",
          key: "e",
          title: "操作",
          width: "",
          center: "left",
          fixed: "right",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span class="action">
                <van-icon
                  name="delete-o"
                  on-click={() => this.deleteRow(rowIndex)}
                ></van-icon>
              </span>
            );
          },
        },
      ],
    };
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        localStorage.setItem(this.orderingKey, JSON.stringify(newVal));
        if (newVal.tableData && newVal.tableData.length > 0) this.calcSum();
        else {
          this.form.totalNum = 0;
          this.form.giftNum = 0;
          this.form.totalAmount = 0;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.type && this.$route.query.type.includes("purchase")) {
      this.queryType = this.$route.query.type;
      this.orderingKey = this.$route.query.type + "ing";
      const queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");
      const orderFrom = JSON.parse(
        localStorage.getItem(this.orderingKey) || "{}"
      );
      let form = Object.assign({}, queryForm, this.form, orderFrom);
      if (!form.scId) {
        const queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");

        form = Object.assign({}, queryForm, form);
      }
      this.form = { ...form };
      if (!this.form.tableData || this.form.tableData.length === 0) {
        this.get(this.form.purchaseOrderId);
      }
    }
  },
  methods: {
    toCategory() {
      this.$router.push({
        path: "/product/category",
        query: { type: this.queryType },
      });
    },
    toDetail(item) {
      this.$router.push({
        path: "/purchase/receiveProductModify/" + item.productId,
        query: { type: "edit" },
      });
    },
    minus(event, i, key) {
      event.stopPropagation();
      if (this.form.tableData[i][key] <= 1 && this.form.tableData[i].isFixed) {
        Toast("采购订单中的商品不允许删除");
        return;
      } else if (
        this.form.tableData[i][key] <= 0 &&
        !this.form.tableData[i].isFixed
      ) {
        this.form.tableData.splice(i, 1);
        return;
      }
      let num = this.$utils.preciseSubtraction(
        Number(this.form.tableData[i][key]),
        1
      );
      this.$set(this.form.tableData[i], key, num);
    },

    plus(event, i, key) {
      event.stopPropagation();

      let num = Number(this.form.tableData[i][key]) + 1;
      this.$set(this.form.tableData[i], key, num);
    },
    close() {
      Dialog.confirm({
        title: "警告",
        message: "关闭页面将会丢失数据，确认关闭？",
      })
        .then(() => {
          this.$router.push({ path: "/dashboard/home" });
        })
        .catch(() => {});
    },
    getPurchaseProduct() {
      return queryPurchaseProductList;
    },
    showToast() {
      Toast.fail("请先选择采购订单");
    },
    toShowProductSelect() {
      if (!this.form.scId) {
        Toast.fail("请先选择仓库");
        return;
      }
      this.showProductSelect = true;
    },
    genParams() {
      const params = {
        scId: this.form.scId,
        supplierId: this.form.supplierId,
        purchaserId: this.form.purchaserId || "",
        paymentDate: this.form.paymentDate || "",
        receiveDate: this.form.receiveDate,
        purchaseOrderId: this.form.purchaseOrderId,
        description: this.form.description || "",
        required: true,
        products: this.form.tableData
          .filter((t) => this.$utils.isFloatGtZero(t.receiveNum))
          .map((t) => {
            const product = {
              productId: t.productId,
              receiveNum: t.receiveNum,
              description: t.description || "",
              productionDate: t.productionDate,
              shelfLifeDays: t.shelfLifeDays,
              shelfLife: this.addDays(t.productionDate, t.shelfLifeDays),
            };

            if (t.isFixed) {
              product.purchaseOrderDetailId = t.id;
            }

            return product;
          }),
      };
      return params;
    },
    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
    validData() {
      if (this.$utils.isEmpty(this.form.scId)) {
        this.$utils.createError("仓库不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.supplierId)) {
        this.$utils.createError("供应商不允许为空！");
        return false;
      }

      if (this.form.allowModifyPaymentDate) {
        if (this.$utils.isEmpty(this.form.paymentDate)) {
          this.$utils.createError("付款日期不允许为空！");
          return false;
        }
      }

      if (this.$utils.isEmpty(this.form.receiveDate)) {
        this.$utils.createError("实际到货日期不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.purchaseOrderId)) {
        this.$utils.createError("采购订单不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.tableData)) {
        this.$utils.createError("请录入商品！");
        return false;
      }

      for (let i = 0; i < this.form.tableData.length; i++) {
        const product = this.form.tableData[i];

        if (this.$utils.isEmpty(product.productId)) {
          this.$utils.createError("第" + (i + 1) + "行商品不允许为空！");
          return false;
        }

        if (this.$utils.isEmpty(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价不允许为空！");
          return false;
        }

        if (!this.$utils.isFloat(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价必须为数字！");
          return false;
        }
        // if (this.$utils.isEmpty(product.productionDate)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品生产日期不允许为空！');
        //   return false;
        // }
        // if (this.$utils.isEmpty(product.shelfLifeDays)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品保质期不允许为空！');
        //   return false;
        // }
        if (product.isGift) {
          if (parseFloat(product.purchasePrice) !== 0) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须等于0！");
            return false;
          }
        } else {
          if (!this.$utils.isTotalNumGtZero(product.purchasePrice)) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须大于0！");
            return false;
          }
        }

        if (!this.$utils.isNumberPrecision(product.purchasePrice, 2)) {
          this.$utils.createError(
            "第" + (i + 1) + "行商品采购价最多允许2位小数！"
          );
          return false;
        }

        if (!this.$utils.isEmpty(product.receiveNum)) {
          if (product.isFixed) {
            if (!this.$utils.isFloatGeZero(product.receiveNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品收货数量不允许小于0！"
              );
              return false;
            }
          } else {
            if (!this.$utils.isTotalNumGtZero(product.receiveNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品收货数量必须大于0并且最多三位小数！"
              );
              return false;
            }
          }

          if (product.isFixed) {
            if (product.receiveNum > product.remainNum) {
              this.$utils.createError(
                "第" +
                  (i + 1) +
                  "行商品累计收货数量为" +
                  (product.orderNum - product.remainNum) +
                  "，剩余收货数量为" +
                  product.remainNum +
                  "，本次收货数量不允许大于" +
                  product.remainNum +
                  "！"
              );
              return false;
            }
          }
        } else {
          if (!product.isFixed) {
            this.$utils.createError(
              "第" + (i + 1) + "行商品收货数量不允许为空！"
            );
            return false;
          }
        }
      }

      if (
        this.form.tableData.filter((item) =>
          this.$utils.isFloatGtZero(item.receiveNum)
        ).length === 0
      ) {
        this.$utils.createError("采购订单中的商品必须全部或部分收货！");
        return false;
      }

      return true;
    },
    toDirectApprovePass() {
      if (!this.validData()) {
        return;
      }
      this.loading = true;
      const params = this.genParams();
      directApprovePass(params)
        .then((res) => {
          Toast.success(res.msg);
          this.$router.push({ path: "/purchase/receive" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onAddConfirm() {
      if (!this.validData()) {
        return;
      }
      this.loading = true;
      const params = this.genParams();

      create(params)
        .then((res) => {
          Toast.success(res.msg);
          this.$router.push({ path: "/purchase/receive" });
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 计算汇总数据
    calcSum() {
      let totalNum = 0;
      let giftNum = 0;
      let totalAmount = 0;

      this.form.tableData
        .filter((t) => {
          return (
            this.$utils.isFloatGeZero(t.purchasePrice) &&
            this.$utils.isFloatGtZero(t.receiveNum)
          );
        })
        .forEach((t) => {
          const num = parseFloat(t.receiveNum);
          if (t.isGift) {
            giftNum = this.$utils.add(giftNum, num);
          } else {
            totalNum = this.$utils.add(totalNum, num);
          }
          totalAmount = this.$utils.add(
            totalAmount,
            this.$utils.mul(num, t.purchasePrice)
          );
        });

      this.form.totalNum = totalNum;
      this.form.giftNum = giftNum;
      this.form.totalAmount = totalAmount;
    },
    showPurchaseOrderSelect() {
      this.purchaseOrderSelectVisible = true;
    },
    emptyProduct() {
      return {
        id: this.$utils.uuid(),
        productId: "",
        productCode: "",
        productName: "",
        skuCode: "",
        externalCode: "",
        unit: "",
        spec: "",
        categoryName: "",
        brandName: "",
        purchasePrice: 0,
        taxCostPrice: "",
        stockNum: "",
        orderNum: "",
        remainNum: "",
        receiveNum: 0,
        taxRate: "",
        isGift: true,
        taxAmount: "",
        description: "",
        isFixed: false,
        products: [],
      };
    },
    get(id) {
      this.loading = true;
      getWithReceive(id)
        .then((res) => {
          const data = res.data;
          const tableData =
            (this.form.tableData &&
              this.form.tableData.filter((item) => !item.isFixed)) ||
            [];
          let purchaseDetails = data.details || [];
          purchaseDetails = purchaseDetails.map((item) => {
            item.isFixed = true;

            return Object.assign({}, this.emptyProduct(), item);
          });

          this.$set(this.form, "tableData", purchaseDetails.concat(tableData));

          this.form.scId = data.scId;

          this.form.supplierId = data.supplierId;

          if (!this.$utils.isEmpty(data.purchaserId)) {
            this.form.purchaserId = data.purchaserId;
          }
          let queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");
          queryForm.supplierId = this.form.supplierId;
          queryForm.scId = this.form.scId;
          localStorage.setItem("queryForm", JSON.stringify(queryForm));
          this.supplierChange(this.form.supplierId);
          this.form.purchaseOrderId = data.id;
        })

        .finally(() => {
          this.loading = false;
        });
    },
    supplierChange(supplierId) {
      getPaymentDate(supplierId).then((res) => {
        this.form.paymentDate = res.data.paymentDate || "";
        this.form.allowModifyPaymentDate = res.data.allowModify;
      });
    },
    inputChange(rowIndex, field, val) {
      this.$set(this.form.tableData, rowIndex, {
        ...this.form.tableData[rowIndex],
        [field]: val,
      });
    },
    openDateTimePicker(type = "product", index) {
      this.datePickType = type;
      this.index = index;
      this.showDatePicker = true;
    },
    deleteRow(index) {
      this.form.tableData.splice(index, 1);
    },
    onSelectProductConfirm(row) {
      if (this.showProductSelect) {
        this.showProductSelect = false;
      }
      if (row.length) {
        row.forEach((el) => {
          this.form.tableData.push({
            ...el,
          });
        });
      }
    },
    onDatePickerConfirm(val) {
      if (!val) return;
      if (this.datePickType == "product") {
        this.$set(this.form.tableData, this.index, {
          ...this.form.tableData[this.index],
          productionDate: val,
        });
      } else {
        this.form[this.index] = val;
      }
      this.showDatePicker = false;
      this.index = 0;
    },
  },
};
</script>
<style scoped lang="less">
.van-cell {
  padding: 5px 0px 5px 15px;
}
#add {
  position: relative;
  /* height: 100vh;
  overflow: auto; */
}
::v-deep .van-field__body {
  height: 100%;
}
.actions-btn {
  .van-button {
    margin: 5px 5px 0 0;
  }
}
.action {
  background-color: #fff;
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-size: 26px;
  height: 36px;
}

.content {
  .product-list {
    background-color: #fff;
    max-height: 60vh;
    overflow: auto;
    .top {
      background-color: #fff;
      padding: 10px;
      font-size: 16px;
    }
    .action {
      background-color: #fff;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 26px;
      height: 36px;
    }
  }

  .product {
    padding-right: 8px;
    font-size: 14px;
    color: #999;
    display: flex;
    width: 100%;
    justify-content: space-between;

    .flex {
      display: flex;
      justify-items: center;
      flex-direction: column;
      align-content: flex-start;
      justify-content: center;
      align-items: flex-start;
    }
    .flex-end {
      align-items: flex-end;
    }
    .tit {
      max-width: 230px;
      font-size: 16px;
      font-weight: 600;
      color: #000;
    }
    .price span {
      font-weight: 500;
      color: #347f5e;
    }
    .total {
      font-weight: 600;
      color: red;
    }
  }
}
.van-cell-group--inset {
  margin: 0px;
  border-radius: 0px;
}
</style>
